import { Component, Element, Prop, h } from '@stencil/core';
import { Color } from '../../../interface';

@Component({
  tag: 'lar-button-push',
  styleUrl: 'button-push.scss',
  scoped: true
})

export class NodeButtonPush {
  @Element() el!: HTMLElement;

  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop() color?: Color = 'primary';

  /**
   * size
   */
  @Prop() size?: ('small' | 'default') = 'default';

  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop() disabled?: boolean = false;

  render() {
   return (
    <lar-button
      style={{"borderRadius": "10px"}}
      color="light"
      disabled={this.disabled}
      size={this.size}
    >
      <slot><lar-icon icon="solid-circle" /></slot>
    </lar-button>
   );
  }
}
